module.exports = __webpack_public_path__ + "img/OAK PPP v3.4a9778b8.png";